import { useQuery } from '@tanstack/react-query'

import { getUserAccountGroups } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchUserAccountGroups = (organizationId: string) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!organizationId,
    queryFn: () => getUserAccountGroups(axiosInstance, organizationId),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_USER_ACCOUNT_GROUPS],
  })

  return { data, isError, isLoading }
}
